<template lang="pug">
.view-user
  ui-navbar-panel.mb-20(backLink="users", backLinkText="К списку")
    template(slot="filters")
      span Новый пользователь

    template
      b-button.is-primary(@click="save", icon-left="check") Сохранить

  .container(v-if="!user.$state.loading")
    form-component(
      v-model="user",
      form="new-user-form",
      ref="form",
      @afterCreate="routeToUser"
    )
</template>

<script>
import User from '@/models/User';
import BButton from 'buefy/src/components/button/Button';
import BField from 'buefy/src/components/field/Field';
import BIcon from 'buefy/src/components/icon/Icon';

export default {
  name: 'view-new-user',

  components: { BIcon, BField, BButton },

  data: () => ({
    user: new User(),
  }),

  methods: {
    save() {
      this.$refs.form.save();
    },

    routeToUser({ id }) {
      this.$router.replace({ name: 'editUser', params: { id } });
    },
  },
};
</script>
